var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, css } from 'styled-components';
import { Human } from '@hn-ui/icons';
import { SkillStatus, ColorByStatus } from '../../constants/statuses';
var ScProgressMark = styled.div.withConfig({ displayName: "ScProgressMark", componentId: "sc-1mj3ioa" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n"], ["\n  position: absolute;\n  ", "\n"])), function (_a) {
    var position = _a.position;
    return position === 'top'
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          top: 3px;\n          left: 50%;\n          transform: translate(-50%, -100%);\n        "], ["\n          top: 3px;\n          left: 50%;\n          transform: translate(-50%, -100%);\n        "]))) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          right: -4px;\n          top: 0;\n          transform: translateX(100%);\n        "], ["\n          right: -4px;\n          top: 0;\n          transform: translateX(100%);\n        "])));
});
var ScStatusIndicator = styled.div.withConfig({ displayName: "ScStatusIndicator", componentId: "sc-ubkron" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n\n  ", "\n"], ["\n  position: relative;\n  display: inline-block;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n\n  ", "\n"])), function (_a) {
    var status = _a.status, shape = _a.shape;
    return "\n    background-color: " + ColorByStatus[status || SkillStatus.NoData] + ";\n    " + (shape === 'rounded' ? 'border-radius: 4px;' : '') + "\n  ";
});
export var StatusIndicator = function (_a) {
    var status = _a.status, _b = _a.shape, shape = _b === void 0 ? 'rounded' : _b, inProgress = _a.inProgress, progressPosition = _a.progressPosition, children = _a.children, rest = __rest(_a, ["status", "shape", "inProgress", "progressPosition", "children"]);
    return (_jsxs(ScStatusIndicator, __assign({ status: status || SkillStatus.NoData, shape: shape }, rest, { children: [inProgress && (_jsx(ScProgressMark, __assign({ position: progressPosition }, { children: _jsx(Human, { size: 16, color: 'black60' }, void 0) }), void 0)), children] }), void 0));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
